import api from "actions/api";
import doRequest from "actions/doRequest";
import ModalWindow from "components/ModalWindow";
import { PdaContext } from "context";
import React, { useContext, useMemo, useState } from "react";
import { Button, Icon, Loader, Table } from "semantic-ui-react";

const DriverInfoModal = ({ intl, logout, pushNotify, id, ...props }) => {
  const { isPda } = useContext(PdaContext);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [driver, setDriver] = useState(null);
  const openModal = () => {
    setLoading(true);

    const req = doRequest(api.driver.driver(id), pushNotify, logout);

    req.ready
      .then((data) => {
        setDriver(data);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });

    setOpen(true);
  };

  const translates = useMemo(
    () => ({
      ok: intl.formatMessage({ id: "btn.ok" }),
      fullNameShort: intl.formatMessage({ id: "title.fullNameShort" }),
      phoneNumber: intl.formatMessage({ id: "user.phoneNumber" }),
      detail: intl.formatMessage({ id: "btn.detail" }),
      driverTitleInfo: intl.formatMessage({ id: "title.driver" }),
      driversLicense: intl.formatMessage({ id: "user.driversLicense" }),
      patronymic: intl.formatMessage({ id: "user.patronymic" }),
    }),
    [intl]
  );

  const getButtons = () => [
    {
      title: translates?.ok,
      onClick: () => setOpen(false),
      disabled: false,
      loading: false,
    },
  ];

  return (
    <ModalWindow
      iconType="info"
      title={translates?.driverTitleInfo}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => openModal()}
      trigger={
        <Button className="infoButton" disabled={!id} icon>
          <Icon name="info circle" />
          {!isPda && <span>{translates?.detail}</span>}
        </Button>
      }
      scrolling={!loading}
      actions={getButtons()}
    >
      {loading ? (
        <Loader active inline="centered" />
      ) : (
        <div className="driverInfo">
          {driver && (
            <Table basic="very" celled collapsing unstackable>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>
                    <b>{translates?.fullNameShort}:</b>
                  </Table.Cell>
                  <Table.Cell>
                    {driver.firstName} {driver.lastName}
                  </Table.Cell>
                </Table.Row>
                {driver.phones.map((phnone) => (
                  <Table.Row>
                    <Table.Cell>
                      <b>{translates?.phoneNumber}:</b>
                    </Table.Cell>
                    <Table.Cell>{phnone}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          )}
        </div>
      )}
    </ModalWindow>
  );
};

export default DriverInfoModal;
